import HttpClient from '@/api/HttpClient';

const httpClient = new HttpClient();

export type TomVendingSiteVisitCashRow = {
  id: number;
  vendingMachineId: number | null;
  assetId: string | null;
  billsCents: number;
  coinsCents: number;
  totalCents: number;
  notes: string | null;
  updatedAt: string;
};

export async function listTomVendingSiteVisitCash(siteVisitId: number): Promise<{
  rows: TomVendingSiteVisitCashRow[];
  granularity: 'machine' | 'site' | null;
}> {
  const response = await httpClient.post('api/tom-vending/site-visit/cash-collected/list', { siteVisitId });
  return response.data as { rows: TomVendingSiteVisitCashRow[]; granularity: 'machine' | 'site' | null };
}

export async function upsertTomVendingSiteVisitCash(params: {
  siteVisitId: number;
  vendingMachineId?: number | null;
  billsCents: number;
  coinsCents: number;
  notes?: string | null;
}): Promise<{ row: TomVendingSiteVisitCashRow }> {
  const response = await httpClient.post('api/tom-vending/site-visit/cash-collected/upsert', params);
  return response.data as { row: TomVendingSiteVisitCashRow };
}

export async function deleteTomVendingSiteVisitCash(params: {
  siteVisitId: number;
  vendingMachineId?: number | null;
}): Promise<{ success: boolean }> {
  const response = await httpClient.post('api/tom-vending/site-visit/cash-collected/delete', params);
  return response.data as { success: boolean };
}

/** Parse dollar string like "12.34" to cents. */
export function parseDollarsToCents(raw: string): number {
  const cleaned = raw.replace(/[^\d.]/g, '');
  if (!cleaned) return 0;
  const n = Math.round(parseFloat(cleaned) * 100);
  return Number.isFinite(n) && n >= 0 ? n : 0;
}

export function formatCentsInput(cents: number): string {
  return (cents / 100).toFixed(2);
}
